import React from 'react';
import {
  Box,
  IconButton,
  HStack,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerCloseButton,
  Stack,
} from '@chakra-ui/react';
import {
  HamburgerIcon,
  SettingsIcon,
  LockIcon,
  EditIcon,
} from '@chakra-ui/icons';
import { IoHomeOutline } from 'react-icons/io5';
import { Link as RouterLink } from 'react-router-dom';

const Header = () => {
  // ドロワーの開閉管理
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box>
      <HStack
        justifyContent="space-between"
        px={8}
        pt={4}
        position="absolute"
        top={0}
        width="100%"
        zIndex={10}
      >
        {/* ハンバーガーボタンでドロワーを開く */}
        <Box display="flex" alignItems="center">
          <IconButton
            aria-label="menu"
            icon={<HamburgerIcon />}
            variant="subtle"
            color="white"
            fontSize="2xl"
            onClick={onOpen}
            _hover={{
              bg: 'rgba(255, 255, 255, 0.1)',
              color: 'white',
            }}
          />

          {/* タイトル */}
          <Box
            as={RouterLink}
            to="/"
            fontSize="xl"
            fontWeight="bold"
            color="white"
            _hover={{ textDecoration: 'underline' }}
            ml={16}
          >
            Pomodoro Timer
          </Box>
        </Box>

        {/* 右側の設定ボタン */}
        <HStack spacing={2}>
          <IconButton
            as={RouterLink}
            to="/settings"
            aria-label="settings"
            icon={<SettingsIcon />}
            variant="ghost"
            color="white"
            fontSize="2xl"
            _hover={{
              bg: 'rgba(255, 255, 255, 0.1)',
              color: 'white',
            }}
          />
        </HStack>
      </HStack>

      {/* ドロワー本体 */}
      <Drawer placement="left" onClose={onClose} isOpen={isOpen}>
        <>
          <DrawerOverlay />
          <DrawerContent bg="white" color="gray.800">
            <DrawerCloseButton />
            <DrawerHeader>メニュー</DrawerHeader>
            <DrawerBody>
              <Stack direction="column" spacing={4}>
                <HStack as={RouterLink} to="/" onClick={onClose}>
                  <IoHomeOutline />
                  <Box>ホーム</Box>
                </HStack>

                <HStack as={RouterLink} to="/privacy" onClick={onClose}>
                  <LockIcon />
                  <Box>プライバシーポリシー</Box>
                </HStack>

                <HStack as={RouterLink} to="/terms" onClick={onClose}>
                  <EditIcon />
                  <Box>利用規約</Box>
                </HStack>

                <HStack as={RouterLink} to="/settings" onClick={onClose}>
                  <SettingsIcon />
                  <Box>設定</Box>
                </HStack>
              </Stack>
            </DrawerBody>
          </DrawerContent>
        </>
      </Drawer>
    </Box>
  );
};

export default Header;
